import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  EVENT_TICKET_PACKAGE_PROFILE_ACTIVITIES_FEATURE_KEY,
  EventTicketPackageProfileActivitiesState,
  eventTicketPackageProfileActivitiesAdapter,
} from './event-ticket-package-profile-activities.reducer'
import * as EventTicketPackageSelectors from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.selectors'

// Lookup the 'EventTicketPackageProfileActivities' feature state managed by NgRx
export const getEventTicketPackageProfileActivitiesState =
  createFeatureSelector<EventTicketPackageProfileActivitiesState>(EVENT_TICKET_PACKAGE_PROFILE_ACTIVITIES_FEATURE_KEY)

const { selectAll, selectEntities } = eventTicketPackageProfileActivitiesAdapter.getSelectors()

export const getAllEventTicketPackageProfileActivities = createSelector(
  getEventTicketPackageProfileActivitiesState,
  (state: EventTicketPackageProfileActivitiesState) => selectAll(state),
)

export const getEventTicketPackageProfileActivitiesEntities = createSelector(
  getEventTicketPackageProfileActivitiesState,
  (state: EventTicketPackageProfileActivitiesState) => selectEntities(state),
)

export const getSelectedId = createSelector(
  getEventTicketPackageProfileActivitiesState,
  (state: EventTicketPackageProfileActivitiesState) => state.selectedId,
)

export const getSelected = createSelector(
  getEventTicketPackageProfileActivitiesEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

export const getPurchasedEventTicketPackagesByProfile = createSelector(getSelected, (entity) => {
  return entity && entity.event_ticketing_summary
    ? entity.event_ticketing_summary.ticket_packages_purchased +
        entity.event_ticketing_summary.pending_ticket_package_purchases
    : 0
})

export const getRemainingEventTicketPackagesByProfile = createSelector(
  getSelected,
  EventTicketPackageSelectors.selectedEventTicketPackage,
  (entity, currentEventTicketPackage) => {
    if (!currentEventTicketPackage?.ticket_packages_remaining) return 0
    if (entity?.event_ticketing_summary) return entity.event_ticketing_summary.ticket_packages_remaining

    // if profile has no previous purchases of ticket package
    return currentEventTicketPackage.max_ticket_packages_per_person >
      currentEventTicketPackage.ticket_packages_remaining
      ? // return ticket packages remaining if less than max units pp
        currentEventTicketPackage.ticket_packages_remaining
      : // return max units pp
        currentEventTicketPackage.max_ticket_packages_per_person
  },
)
